import React from "react";
import { graphql, useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment$key } from "@relay/DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment.graphql";
import { CurrencyDisplay } from "../../../components/CurrencyDisplay";

const SEARCH_DISCOUNT_USAGE_RESULT_FRAGMENT = graphql`
	fragment DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment on SearchDiscountCodeUsagesResult {
		sumGrossPriceWithDiscounts
		sumGrossPriceWithoutDiscounts
	}
`;

type OwnProps = {
	searchDiscountUsageResultFragmentRef: DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment$key;
};

export const DiscountUsagePriceDisplay = ({ searchDiscountUsageResultFragmentRef }: OwnProps) => {
	const { t } = useTranslation("common");

	const searchDiscountUsageResult =
		useFragment<DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment$key>(
			SEARCH_DISCOUNT_USAGE_RESULT_FRAGMENT,
			searchDiscountUsageResultFragmentRef,
		);

	return (
		<div className="grid">
			<div className="col-6">{t("discountCode.usagePriceDisplay.withDiscounts")}</div>
			<CurrencyDisplay
				className="col-6"
				value={searchDiscountUsageResult.sumGrossPriceWithDiscounts}
			/>
			<div className="col-6">{t("discountCode.usagePriceDisplay.withoutDiscounts")}</div>
			<CurrencyDisplay
				className="col-6"
				value={searchDiscountUsageResult.sumGrossPriceWithoutDiscounts}
			/>
		</div>
	);
};
